function roundAmount(number) {
  return Math.round(number * 100) / 100;
};

export {
  roundAmount
}